import {
  DocumentType,
  Domain,
  FileLabel,
  GoogleDrive,
  GoogleMimeTypes,
  GoogleRessourceRole,
  Like,
  People,
  Rating,
  TagDatamart,
} from 'app/types/index';

export interface canUnflagFileResponse {
  /** Can unflag file */
  can_unflag: boolean;
}

export interface canUnverifyFileResponse {
  /** Can unverify file */
  can_unverify: boolean;
}

export interface FileResponse {
  /** The file. */
  file: FileDto;

  /** The user permissions associated to this file */
  user_permissions?: GoogleRessourceRole;
}

export interface GetFileResponse {
  /** The file. */
  file: PopulatedFileDto;

  /** The user permissions associated to this file */
  user_permissions?: GoogleRessourceRole;
}

export interface FileDto {
  id: string;
  drive_id: string | null;
  domain: Domain;
  name: string | null;
  archived: boolean;
  description: string | null;
  file_extension: string;
  created_by: People;
  contributors: People[];
  ratings: Rating[];
  likes: Like[];
  labels: FileLabel[];
  tags: TagDatamart[];
}

export interface PopulatedFileDto extends FileDto {
  mime_type: string;
  webview_link: string;
  icon_link: string;
  last_modified: Date;
  is_locked: boolean;
}

export enum FileErrorReason {
  ALREADY_VERIFIED = 'ALREADY_VERIFIED',
  ALREADY_FLAGGED = 'ALREADY_FLAGGED',
  VERIFICATION_ALREADY_REQUESTED = 'VERIFICATION_ALREADY_REQUESTED',
  NOT_ENOUGH_PERMISSIONS = 'NOT_ENOUGH_PERMISSIONS',
  NOT_FOUND = 'NOT_FOUND',
  UNKNOWN = 'UNKNOWN',
  NOT_WATCHED_BY_OVERLAYER = 'NOT_WATCHED_BY_OVERLAYER',
  DRIVE_ACCESS_LOST = 'DRIVE_ACCESS_LOST',
  NO_ONGOING_VERIFICATION = 'NO_VERIFICATION_ONGOING',
  IS_SECRET = 'IS_SECRET',
  NO_DEDICATED_USER_FOR_DOMAIN = 'NO_DEDICATED_USER_FOR_DOMAIN',
  MY_DRIVE = 'MY_DRIVE',
  NO_OVERLAYER_LABELS = 'NO_OVERLAYER_LABELS',
  NO_HISTORY = 'NO_HISTORY',
  NOT_VERIFIED = 'NOT_VERIFIED',
}
